<template>
    <div :class="'date-range-container ' + containerClass">
        <div class="col-12 p-0 m-0">
            <span v-if='showLabels'>{{ $t('translations.date_from')}}</span>
            <input type='date' data-next='date_to' v-model="value['date_from']" :class="inputClass" />
        </div>
        <div class='align-self-center pl-1 pr-1'> {{separator}} </div>
        <div class="col-12 p-0 m-0">
            <span v-if='showLabels'>{{ $t('translations.date_to')}}</span>
            <input type='date' v-model="value['date_to']" :class="inputClass" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'date-range',
    props: {
        value: {

        },
        inputClass: {
            type: String,
            default: "form-control nospin"
        },
        containerClass: {
            type: String,
            default: "d-flex justify-content-between ",
        },
        showLabels: String,
        separator: {
            type: String,
            default: "and",
        }
    },
    data() {
        return {
            date_from: null,
            date_to: null,
        };
    },
    computed: {
        
    },
    watch: {
        
    },
    methods: {
        
    },
};
</script>